import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Hero from "@/pages/home/components/Hero";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import LatestClips from "@/pages/home/components/LatestClips";
import DanmakuWall from "@/pages/home/components/DanmakuWall";
import QuoteSpotlight from "@/pages/home/components/QuoteSpotlight";
import FaqSection from "@/pages/home/components/FaqSection";
import { clips, faqs } from "@/mocks/clips";

const SITE_URL = "https://wqxtv.cn";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "爆料现场",
    url: SITE_URL,
    inLanguage: "zh-CN",
    description:
      "整理爆料直播中的爆料片段、主播关键发言、弹幕热议与高能时刻剪辑，提供直播内容文字版。",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/clips?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "爆料现场",
    url: SITE_URL,
    email: "clip@baoliaoxianchang.com",
    description: "公开直播高能片段的整理与索引平台，专注爆料直播内容的二次归档。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "今日高能爆料片段",
    itemListElement: [...clips]
      .sort((a, b) => b.hot - a.hot)
      .slice(0, 5)
      .map((clip, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: clip.title,
        url: `${SITE_URL}/clip/${clip.id}`,
      })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="爆料现场 | 爆料直播高能片段、主播关键发言与弹幕热议档案馆"
        description="爆料现场整理爆料直播中的爆料片段，主播关键发言一字不漏，直播弹幕热议回顾现场气氛，高能时刻剪辑与直播内容文字版随时可看。"
        keywords="爆料直播,直播中爆料片段,主播关键发言,直播弹幕热议,高能时刻剪辑,直播内容文字版"
        canonical={SITE_URL}
        jsonLd={jsonLd}
      />

      <Hero />
      <CategoryGrid />
      <HotRanking />
      <LatestClips />
      <DanmakuWall />
      <QuoteSpotlight />

      <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col items-center gap-6 rounded-lg border border-background-200 bg-secondary-50 px-6 py-10 text-center md:px-12 md:py-14 dark:bg-secondary-950/50">
          <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-500 text-background-50">
            <i className="ri-radar-line text-2xl" />
          </span>
          <h2 className="max-w-2xl font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            现场只有一次，但记录可以留下
          </h2>
          <p className="max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            如果你刚好看到了某个值得被记住的爆料瞬间，把场次、时间点和大致内容发给我们。
            编辑会核对公开录播后完成整理，并标注来源场次。
          </p>
          <div className="flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/clips"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-compass-3-line" />
              去片段库逛逛
            </Link>
            <Link
              to="/about"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-secondary-400 sm:w-auto"
            >
              <i className="ri-mail-send-line" />
              提交爆料线索
            </Link>
          </div>
        </div>
      </section>

      <FaqSection />
    </>
  );
}